var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('img',{attrs:{"src":_vm.setImageUrl(_vm.options.image),"alt":""}}),_c('p',{class:_vm.options.classes},[_vm._v(_vm._s(_vm.options.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }